import axios from "axios";
import React, { useEffect, useState } from "react";
import Button from "../../components/button/button.component";
import "./checkout.styles.css";

const CheckoutComponent = () => {
  // stateهای مربوط به اطلاعات کاربر و خطاهای فرم
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // سبد خرید (خواندن از localStorage)
  const [cart, setCart] = useState([]);

  // آدرس‌های کاربر (از وب سرویس خوانده می‌شود)
  const [addresses, setAddresses] = useState([]);

  // برای افزودن آدرس جدید
  const [newAddressTitle, setNewAddressTitle] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [newPostalCode, setNewPostalCode] = useState("");

  // آیدی آدرس انتخاب‌شده
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  // گرفتن توکن از LocalStorage
  const token = localStorage.getItem("access_token");

  // تابع فراخوانی پروفایل
  const fetchProfile = async () => {
    if (!token) {
      console.log("No token found, redirect or handle error...");
      return;
    }

    setLoading(true);
    try {
      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/profile",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.request(config);
      console.log("Profile Response:", response.data);

      if (response.data.is_status) {
        const data = response.data.data;

        // جدا کردن firstName و lastName از full_name
        const fullNameParts = data.full_name.trim().split(" ");
        const firstName = fullNameParts[0] || "";
        const lastName = fullNameParts.slice(1).join(" ") || "";

        // پر کردن فرم با داده‌های دریافت شده
        setFormData((prev) => ({
          ...prev,
          firstName,
          lastName,
          phone: data.phone || "",
          email: data.email || "",
        }));

        // ساخت آرایه آدرس‌ها بر اساس داده دریافتی
        if (Array.isArray(data.address)) {
          const fetchedAddresses = data.address.map((addr) => ({
            id: addr.id,
            title: addr.title,
            postCode: addr.post_code,
            address: addr.address,
          }));
          setAddresses(fetchedAddresses);
        }
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  // استفاده از fetchProfile در useEffect
  useEffect(() => {
    // خواندن سبد خرید از localStorage
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);

    // فراخوانی پروفایل کاربر
    fetchProfile();
  }, [token]);

  // تابع اعتبارسنجی فرم
  const validateForm = () => {
    const errors = {};
    if (!formData.firstName.trim()) {
      errors.firstName = "وارد کردن نام الزامی است.";
    }
    if (!formData.lastName.trim()) {
      errors.lastName = "وارد کردن نام خانوادگی الزامی است.";
    }
    if (!formData.phone.trim()) {
      errors.phone = "شماره تماس الزامی است.";
    }
    if (!formData.email.trim()) {
      errors.email = "ایمیل الزامی است.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "ایمیل معتبر نیست.";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // تغییر اطلاعات فرم (این فیلدها readOnly هستند، پس این تابع ممکن است برای تغییر توسط کاربر استفاده نشود)
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddAddress = async () => {
    if (
      !newAddressTitle.trim() ||
      !newAddress.trim() ||
      !newPostalCode.trim()
    ) {
      alert("لطفاً تمام فیلدهای آدرس را پر کنید.");
      return;
    }

    if (!token) {
      alert("برای افزودن آدرس باید وارد حساب کاربری خود شوید.");
      return;
    }

    setLoading(true);

    try {
      // ایجاد داده‌های فرم
      const data = new FormData();
      data.append("title", newAddressTitle);
      data.append("address", newAddress);
      data.append("post_code", newPostalCode);

      // تنظیمات درخواست
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/create-address",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: data,
      };

      // ارسال درخواست
      const response = await axios.request(config);
      console.log("Create Address Response:", response.data);

      if (response.data.is_status) {
        const newAddrObj = {
          id: response.data.data.id, // گرفتن ID آدرس جدید از سرور
          title: newAddressTitle,
          postCode: newPostalCode,
          address: newAddress,
        };

        // اضافه کردن آدرس جدید به لیست و تنظیم آدرس انتخاب‌شده به آدرس جدید
        setAddresses((prevAddresses) => [...prevAddresses, newAddrObj]);
        setSelectedAddressId(newAddrObj.id);

        // پاک کردن فیلدهای افزودن آدرس
        setNewAddressTitle("");
        setNewAddress("");
        setNewPostalCode("");

        // فراخوانی مجدد fetchProfile برای بارگذاری آدرس‌های جدید
        await fetchProfile();

        alert("آدرس جدید با موفقیت اضافه شد.");
      } else {
        alert("خطایی در افزودن آدرس رخ داد، لطفاً دوباره تلاش کنید.");
      }
    } catch (error) {
      console.error("Error adding address:", error);
      alert("خطایی در افزودن آدرس رخ داد.");
    } finally {
      setLoading(false);
    }
  };

  const updateAddresses = async (updatedAddresses) => {
    if (!token) return;

    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      // ارسال تنها بخش آدرس‌ها
      address: updatedAddresses.map((addr) => ({
        title: addr.title,
        post_code: addr.postCode,
        address: addr.address,
      })),
    };

    try {
      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/update-profile",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      };

      const res = await axios.request(config);
      console.log("Update Addresses Response:", res.data);
      if (res.data.is_status) {
        alert("آدرس ثبت شد");
      } else {
        alert("خطا در به‌روزرسانی آدرس‌ها");
      }
    } catch (error) {
      console.error(error);
      alert("خطایی رخ داد");
    }
  };

  // هندل ثبت سفارش

  const handleProceedToCheckout = async () => {
    if (!validateForm()) {
      return;
    }

    const chosenAddress = addresses.find((a) => a.id === selectedAddressId);
    if (!chosenAddress) {
      alert("لطفاً یک آدرس انتخاب کنید.");
      return;
    }

    try {
      setLoading(true);
      setMessage("در حال ثبت سفارش...");

      // ساخت payload به صورت JSON طبق نمونه داده شده
      const payload = {
        campaign_id: 2, // المان ثابت
        address_id: chosenAddress.id, // از آدرس انتخاب شده
        products: cart.map((item) => ({
          id: item.id,
          quantity: item.quantity.toString(),
          color: item.colorId ? item.colorId.toString() : "0",
        })),
      };

      console.log("Payload for checkout:", payload);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/shopping-cart",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      };

      const response = await axios.request(config);
      console.log("Response from checkout API:", response.data);

      if (response.data.is_status) {
        const bankUrl = response.data.data.url;
        console.log("Bank URL:", bankUrl);

        localStorage.removeItem("cart");
        setCart([]);

        window.location.href = bankUrl;
      } else {
        setMessage("مشکلی در ارتباط با درگاه پرداخت پیش آمد.");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("خطایی در ثبت سفارش رخ داد.");
    } finally {
      setLoading(false);
    }
  };

  // اگر اطلاعات در حال دریافت است، فقط اسپینر نمایش داده شود
  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner-profile"></div>
      </div>
    );
  }

  // اگر توکن وجود نداشته باشد، پاپ‌آپ ورود نمایش داده شود
  if (!token) {
    return (
      <div className="login-popup-container">
        <div className="login-popup">
          <p className="login-popup-text">
            برای ثبت نهایی خرید ابتدا وارد حساب کاربری خود شوید
          </p>
          <Button
            className="login-popup-button"
            onClick={() => (window.location.href = "/login-register")}
          >
            ورود به حساب
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-container">
      <h2 className="title-checkout">جزئیات سفارش</h2>

      <form className="checkout-form">
        <div className="form-group-rtl">
          <label htmlFor="firstName">نام</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            readOnly
            value={formData.firstName}
            onChange={handleFormChange}
            className={formErrors.firstName ? "error" : ""}
          />
          {formErrors.firstName && (
            <span className="error-text">{formErrors.firstName}</span>
          )}
        </div>

        <div className="form-group-rtl">
          <label htmlFor="lastName">نام خانوادگی</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            readOnly
            value={formData.lastName}
            onChange={handleFormChange}
            className={formErrors.lastName ? "error" : ""}
          />
          {formErrors.lastName && (
            <span className="error-text">{formErrors.lastName}</span>
          )}
        </div>

        <div className="form-group-rtl">
          <label htmlFor="phone">شماره تماس</label>
          <input
            type="text"
            id="phone"
            name="phone"
            readOnly
            value={formData.phone}
            onChange={handleFormChange}
            className={formErrors.phone ? "error" : ""}
          />
          {formErrors.phone && (
            <span className="error-text">{formErrors.phone}</span>
          )}
        </div>

        <div className="form-group-rtl">
          <label htmlFor="email">ایمیل</label>
          <input
            type="email"
            id="email"
            name="email"
            readOnly
            value={formData.email}
            onChange={handleFormChange}
            className={formErrors.email ? "error" : ""}
          />
          {formErrors.email && (
            <span className="error-text">{formErrors.email}</span>
          )}
        </div>
        <p>
          این اطلاعات فقط برای نمایش به کاربر است و در صورت نیاز به تغییر و
          به‌روزرسانی به بخش حساب کاربری بروید.
        </p>
      </form>

      {/* آدرس‌های کاربر */}
      <div className="addresses-container">
        <h3> آدرس خود را انتخاب کنید </h3>
        {addresses.map((addr) => (
          <div
            key={addr.id}
            className={`address-card ${
              selectedAddressId === addr.id ? "selected-address" : ""
            }`}
            onClick={() => setSelectedAddressId(addr.id)}
          >
            <label className="radio-label">
              <input
                type="radio"
                name="selectedAddress"
                checked={selectedAddressId === addr.id}
                onChange={() => setSelectedAddressId(addr.id)}
              />
              <span>
                <strong>{addr.title}</strong>
                <p>{addr.address}</p>
                <p className="postal-code">کد پستی: {addr.postCode}</p>
              </span>
            </label>
          </div>
        ))}

        <h4>افزودن آدرس جدید</h4>
        <div className="add-address">
          <input
            type="text"
            placeholder="عنوان آدرس (مثلاً خانه، محل کار...)"
            value={newAddressTitle}
            onChange={(e) => setNewAddressTitle(e.target.value)}
          />
          <input
            type="text"
            placeholder="آدرس جدید را وارد کنید..."
            value={newAddress}
            onChange={(e) => setNewAddress(e.target.value)}
          />
          <input
            type="text"
            placeholder="کد پستی..."
            value={newPostalCode}
            onChange={(e) => setNewPostalCode(e.target.value)}
          />
          <Button className="add-address-btn" onClick={handleAddAddress}>
            افزودن آدرس
          </Button>
        </div>
      </div>

      <Button
        className="proceed-button"
        onClick={handleProceedToCheckout}
        disabled={
          loading ||
          message === "سفارش ثبت شد! در حال انتقال به درگاه پرداخت..."
        }
      >
        {loading ? (
          <span className="spinner-container-cart">
            <span className="spinner-cart"></span> در حال ثبت سفارش...
          </span>
        ) : (
          "ثبت و پرداخت"
        )}
      </Button>

      <p className="alert-text">
        **برای انتقال به درگاه پرداخت فیلتر شکن خود را خاموش کنید**
      </p>

      {message && <p className="status-message">{message}</p>}
    </div>
  );
};

export default CheckoutComponent;
